module.exports = __webpack_public_path__ + "static/media/edig-ad.dd2bc7db.png";